import axios from "fetch-api/fetch-api";
import { ISendMessageReq } from "../interfaces/contact-api.type";

export default function sendMessageApi(sendMessageReq: ISendMessageReq) {
  return axios.post<void>("/contact-us-v3", sendMessageReq);
}
